import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

/* ===== LAYOUT ===== */
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

/* ===== PUBLIC PAGES ===== */
import Home from "./pages/Home";
import Shop from "./pages/shop.jsx";
import Gallery from "./pages/Gallery";
import BookHearse from "./pages/BookHearse";
import Contact from "./pages/Contact";
import Cars from "./pages/cars.jsx";
import NotFound from "./pages/NotFound";


/* ===== ADMIN PAGES ===== */
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminGallery from "./pages/AdminGallery";
import AdminUsers from "./pages/AdminUsers";
import AdminCustomers from "./pages/AdminCustomer";
import AdminBookings from "./pages/AdminBookings";
import AdminCars from "./pages/AdminCars";
import ImageUploader from "./pages/ImageUploader";
import AdminShop from "./pages/AdminShop";

export default function App() {
  return (
    <BrowserRouter>
      {/* NAVBAR ON ALL PUBLIC PAGES */}
      <Navbar />

      <Routes>
        {/* ===== PUBLIC ROUTES ===== */}
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/book" element={<BookHearse />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cars" element={<Cars />} />
        <Route path="*" element={<NotFound />} />


        {/* ===== ADMIN AUTH ===== */}
        <Route path="/login" element={<AdminLogin />} />

        {/* ===== ADMIN PROTECTED ROUTES ===== */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute allow="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        <Route
  path="/admin/image-uploader"
  element={
    <ProtectedRoute>
      <ImageUploader />
    </ProtectedRoute>
  }
/>
 <Route
          path="/admin/shop"
          element={
            <ProtectedRoute allow="admin">
              <AdminShop />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/cars"
          element={
            <ProtectedRoute allow="admin">
              <AdminCars />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/gallery"
          element={
            <ProtectedRoute allow="admin">
              <AdminGallery />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/bookings"
          element={
            <ProtectedRoute allow="admin">
              <AdminBookings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/users"
          element={
            <ProtectedRoute allow="admin">
              <AdminUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/customers"
          element={
            <ProtectedRoute allow="admin">
              <AdminCustomers />
            </ProtectedRoute>
          }
        />  

        {/* ===== FALLBACK ===== */}
        <Route path="/admin/*" element={<Navigate to="/admin/dashboard" />} />
      </Routes>

      {/* FOOTER ON ALL PUBLIC PAGES */}
      <Footer />
    </BrowserRouter>
  );
}
